module.exports = __webpack_public_path__ + "img/faculty-lisa.11a4d6ce.png";